import { object, string } from 'yup';

export function validationSchema() {
  return object().shape({
    ownerURL: string().when('enabled', {
      is: true,
      then: string().required('Обязательное поле'),
    }),
    ownerUsername: string().when('enabled', {
      is: true,
      then: string().required('Обязательное поле'),
    }),
    ownerPassword: string().when('enabled', {
      is: true,
      then: string().required('Обязательное поле'),
    }),
  });
}
